module.exports = __webpack_public_path__ + "static/media/TransportLogo.4de7d5d4.svg";